import { ReactFlowProvider } from "@xyflow/react";
import SequenceCanvas from "./SequenceCanvas";

export default function SequencePreviewBody() {
  return (
    <div className="w-full h-full">
      <SequenceCanvas />
    </div>
  );
}
